import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getBrand } from '../apis';

export const useSoleProprietorCheck = (
  brandId: string
): { isLoading: boolean } => {
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    const checkIsSoleProp = async () => {
      try {
        setIsLoading(true);
        const brand = await getBrand(brandId);
        if (brand && brand.entityType === 'SOLE_PROPRIETOR') {
          history.replace('/404');
        }
      } catch (error) {
        // silently handle errors to allow users to continue using the page
      } finally {
        setIsLoading(false);
      }
    };

    checkIsSoleProp();
  }, [brandId, history]);

  return { isLoading };
};
